/**
 * Listeners for the Organization feature.
 * Registered once from `store.ts`.
 */

import { startAppListening } from './index';
import { createOrganization } from '../actions/organizationThunks';
import { fetchCurrentUser } from '../actions/userThunks';

export function registerOrganizationListeners(): void {
    // After creating an org, `users.org_id`/`org_role` changed server-side —
    // refetch the current user so the rest of the app (SideNav org badge,
    // future org-role gating) sees it. Reuses the accessToken already acquired
    // for the create call (available on the fulfilled action's `meta.arg`),
    // rather than re-acquiring a token from outside the React tree.
    startAppListening({
        actionCreator: createOrganization.fulfilled,
        effect: async (action, listenerApi) => {
            listenerApi.dispatch(fetchCurrentUser({ accessToken: action.meta.arg.accessToken }));
        },
    });
}
